import React, { memo } from 'react';
import PropTypes from 'prop-types';
import length from 'ramda/src/length';
import Track from './Track';

function List(props) {
    const { data, userRole, onSelect, onToggle } = props;
    return (
        <>
            <div className="d-flex py-2">
                <div className="d-flex-6 dsl-m12">Tracks</div>
                <div className="d-flex-1 dsl-m12">Courses</div>
                <div className="d-flex-1 dsl-m12">Modules</div>
                <div className="d-flex-1 dsl-m12">Assigned</div>
            </div>
            {data.map((item, index) => (
                <Track
                    key={`${item.id}-${index}`}
                    userRole={userRole}
                    name={item.name || item.title}
                    description={item.data.description || item.description}
                    thumbnail={item.data.thumbnail || item.thumbnail}
                    courses={length(item.data.cards)}
                    modules={item.data.module_count}
                    assigned={item.data.assigned}
                    published={item.published}
                    trackCount={length(data)}
                    onSelect={(e) => onSelect(e, item)}
                    onToggle={() => onToggle(item.id, 'view')}
                />
            ))}
        </>
    );
}

List.propTypes = {
    userRole: PropTypes.number,
    data: PropTypes.array,
    onModal: PropTypes.func,
    onToggle: PropTypes.func,
    onAddTrack: PropTypes.func,
};

List.defaultProps = {
    userRole: 1,
    data: [],
    onModal: () => {},
    onToggle: () => {},
    onAddTrack: () => {},
};

export default memo(List);
